import { InfoOutlineIcon } from '@chakra-ui/icons'
import { Button, type ButtonProps } from '@chakra-ui/react'
import type { WizardConfig } from './types'
import { useWizard } from './useWizard'

interface WizardButtonProps extends Omit<ButtonProps, 'onClick'> {
	wizard: WizardConfig
	/** Se true, forza la riapertura anche se già completato. Default: true */
	force?: boolean
}

/**
 * Bottoneche avvia un wizard passato come prop.
 * Gestisce internamente `useWizard` — non serve importarlo nel componente padre.
 *
 * @example
 * ```tsx
 * <WizardButton wizard={myWizardConfig} />
 * ```
 */
export function WizardButton({ wizard, force = true, children, ...buttonProps }: WizardButtonProps) {
	const { startWizard } = useWizard()

	return (
		<Button data-wizard="guida" size="md" variant="solid" colorScheme="blue" leftIcon={<InfoOutlineIcon />} flexShrink={0} onClick={() => startWizard(wizard, force)} {...buttonProps}>
			{children ?? 'Guida'}
		</Button>
	)
}
